import { ListSvgInterface } from 'app/models/svg/interfaces/svgList.interface';

export const circleSvg: ListSvgInterface = {
  svg: `<circle cx="150" cy="150" r="149.5" stroke="#010318" />`,
  viewBox: `0 0 148 74`,
};
